import ModelEntity from "../model-entity";
import {EntityType} from "../../gd/const/item";
import {REPORT_VIEW_TYPES, ViewType} from "../../gd/const/views/view-type";
import {ViewScope} from "./@const";
import ApiView from "../../gd/api/view";
import SavedView from "../saved-view/saved-view";
import ProjectSession from "../project/project-session";


export default class View extends ModelEntity {

    public name                 : string
    public description          : string


    public icon                 : string    = '' // isvg icon
    public type                 : ViewType
    public scope                : ViewScope    = ViewScope.ORGANIZATION     // ???

    public settings             : any // but we might want settings proto

    public savedView?       : SavedView // this is var is used to load saved views
    public savedData        : any //  !!!! CHECK IF IN USEE !!!! this is var is used to load saved views

    public conditionsForm       : any   = "" // need errro component here

    public projectCustomViewProject?             : ProjectSession // if set it means that this view is resource i.e. it is save in gd.session.projects...

    constructor(data:any, type: ViewType, entityType: EntityType) {
        super(data['id'], entityType)

        this.type                       = type
        this.name                       = data.name
        this.description                = data.description || "No description found"
        this.icon                       = data.icon || ""

        this.savedView                  = data.savedView

        this.scope                      = data.scope || ViewScope.ORGANIZATION
        this.projectCustomViewProject   = data.projectCustomViewProject

    }

    static initFromSavedView(savedView:SavedView) {
        // throw Error("#0498473 it should be in view class !!!! ")
        console.error("#0498473 it should be in view class !!!! ")
    }

    get isSavedView():boolean {
        return !!this.savedView
    }

    get isReport(): boolean {
        return REPORT_VIEW_TYPES.includes(this.type)
    }

    async saveView (payload: JSONObject) {

        try{
            await ApiView.createView(payload).promise()

            gd.growl.success("Saved successfully")
        }
        catch(e){
            gd.growl.error("Something went wrong")
            console.error(e)
        }
    }

    toJSON():JSONObject {
        // should be redefined in child
        return {
            id      : this.id,
            type    : this.type,
            scope   : this.scope
        }
    }
}
